import axios from 'axios';
import qs from 'qs';
import { store, setError429 } from 'store';
import { getEnv, magicNumbers, resetAccount } from 'utils';

const path = getEnv('REACT_APP_BASE_API');

const getStorageToken = () => {
  const currentUser = JSON.parse(
    localStorage.getItem('root:user') || null
  )?.currentUser;
  return JSON.parse(currentUser || null)?.access_token;
};

const headers = (customHeader) => {
  const _headers = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const token =
    store.getState().accountReducer.currentUser?.access_token ||
    getStorageToken();
  if (token) {
    _headers.headers.Authorization = token;
  }

  _headers.headers = { ..._headers.headers, ...customHeader };

  return _headers;
};

function isLoginRequest(config) {
  return config.url.includes('/user/login') && config.method === 'post';
}

function isLoggedIn() {
  return store.getState().authReducer.isLoggedIn;
}

const excludeRoutes = [
  { route: '/user/login', method: 'post' },
  { route: '/aia/summarize', method: 'post' },
];

const isExcluded = (config) => {
  return excludeRoutes.some(
    (item) => config.url.includes(item.route) && config.method === item.method
  );
};

const getFullUrl = (address) => {
  return address.startsWith('http://') || address.startsWith('https://')
    ? address
    : path + address;
};

axios.interceptors.response.use(
  (response) => {
    // store.dispatch(setOnlineStatus(true));
    return response;
  },
  (error) => {
    // if (!error.response) {
    //   store.dispatch(setOnlineStatus(false));
    // }

    if (error?.response?.status === 429 && !isExcluded(error.config)) {
      store.dispatch(
        setError429({
          type: error?.response?.data?.errors?.data?.type,
          active: true,
          ttl:
            error?.response?.data?.errors?.data?.ttl ||
            magicNumbers?.EVERY_FIFTEEN_MINUTES_IN_SECOND,
        })
      );
    } else if (
      error?.response?.status === 401 &&
      !isLoginRequest(error.config) &&
      isLoggedIn()
    ) {
      resetAccount();
    }

    return Promise.reject(error);
  }
);

const apiGet = (address, query, customHeader, cancellation) => {
  if (query) {
    const queryString = qs.stringify(query);
    address = `${address}?${queryString}`;
  }
  const fullUrl = getFullUrl(address);
  return cancellation
    ? axios.get(fullUrl, { ...cancellation, ...headers(customHeader) })
    : axios.get(fullUrl, headers(customHeader));
};
const apiPost = (address, data, customHeader, cancellation) => {
  const fullUrl = getFullUrl(address);
  return cancellation
    ? axios.post(fullUrl, data, {
        ...cancellation,
        ...headers(customHeader),
      })
    : axios.post(fullUrl, data, headers(customHeader));
};
const apiPut = (address, data, customHeader) => {
  return axios.put(getFullUrl(address), data, headers(customHeader));
};
const apiPatch = (address, data, customHeader) => {
  return axios.patch(getFullUrl(address), data, headers(customHeader));
};
const apiRemove = (address, data, customHeader) => {
  return axios.delete(getFullUrl(address), { data, ...headers(customHeader) });
};
const apiAll = (arrMethodes) => {
  return axios.all(arrMethodes);
};

export { apiGet, apiPost, apiPut, apiPatch, apiRemove, apiAll };
